module.exports = __webpack_public_path__ + "img/FinanceStatistic.b4a5ca33.svg";